import { ArrowRight } from '@/components/icon'
export function orderPagination(page, pageCount, clickHandler) {
  const arrowAttrs = Object.keys(ArrowRight.attrs).map(key => ` ${key}="${ArrowRight.attrs[key]}"`).join('')
  return {
    value: Number(page),
    pageCount,
    prevText: `<div><svg${arrowAttrs}><g transform="rotate(180 12 12)">${ArrowRight.path}</g></svg></div>`,
    nextText: `<div><svg${arrowAttrs}>${ArrowRight.path}</svg></div>`,
    containerClass: 'pagination',
    pageClass: 'pagination-item',
    prevClass: 'pagination-prev',
    nextClass: 'pagination-next',
    clickHandler
  }
}
